import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OneWebComponentsAngularModule } from '@one/angular';

@Component({
  selector: 'dl-cf-feedback-template-dropdown',
   standalone: true,
  imports:[OneWebComponentsAngularModule,CommonModule,FormsModule,ReactiveFormsModule],
  templateUrl: './cf-feedback-template-dropdown.component.html',
  styleUrls: ['./cf-feedback-template-dropdown.component.scss']
})

export class CfFeedbackTemplateDropdownComponent implements OnInit, OnChanges {
  
  @Input() public data: Array<string> = [];
  @Input() public feedbackType: any = 'Dropdown';
  @Output() public confirmEvent = new EventEmitter<any>();
  @Output() public cancelEvent = new EventEmitter<void>();
  
  public opts: string = '';
  public optArr: Array<string> = [];
  public optIndex: number = 0;
  public updateFlag: boolean = false;
  public disableFlag: boolean = false;
  public isConfirm: boolean = false;
  public charLimit: number = 50;
  public fieldFlag: boolean = true;
  public dupOpts: boolean = false;
  
  constructor(
    // public dialogRef: MatDialogRef<CfFeedbackTemplateDropdownComponent>,
    // private readonly oneSnackBar?: OneSnackBarService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['feedbackType']) {
      const typeValue = this.extractTypeValue(this.feedbackType);
      this.charLimit = typeValue === 'Radio' ? 500 : 50;
    }
  }
  
  private extractTypeValue(feedbackType: any): string {
    if (!feedbackType) return 'Dropdown';
    if (typeof feedbackType === 'string') {
      return feedbackType;
    }
    if (Array.isArray(feedbackType) && feedbackType.length > 0) {
      return this.extractTypeValue(feedbackType[0]);
    }
    if (typeof feedbackType === 'object') {
      if (feedbackType.label) {
        return String(feedbackType.label);
      }
      if (feedbackType.value) {
        return String(feedbackType.value);
      }
    }
    return String(feedbackType);
  }
    
  ngOnInit(): void {
    const typeValue = this.extractTypeValue(this.feedbackType);
    this.charLimit = typeValue === 'Radio' ? 500 : 50;
    if(this.data.length > 0){      
      this.optArr = this.data;
      this.dupOpts = this.hasDupOpt(this.optArr);
      if(!this.dupOpts){
        if (this.optArr.length >= 2 && this.optArr.length <= 10) {
          this.isConfirm = true;
        } else {
          this.isConfirm = false;
        }
      }
      if (this.optArr.length < 10) {
        this.disableFlag = false;
      } else {
        this.disableFlag = true;
      }
    }
  }

  addOpt(): void{
    if(this.opts.length > 0 && this.opts.length <= this.charLimit){
      this.optArr.push(this.opts);
      this.opts = '';
    }else{
      // this.oneSnackBar.open('Please input your option', OneSnackBarType.ERROR);
    }
    if (this.optArr.length >= 2 && this.optArr.length <= 10) {
      this.isConfirm = true;
      if(this.optArr.length == 10) {
        this.updateFlag = false;
        this.fieldFlag = false;
      }
    } else {
      this.isConfirm = false;
    }
    if (this.optArr.length < 10) {
      this.disableFlag = false;
    } else {
      this.disableFlag = true;
    }

    this.dupOpts = this.hasDupOpt(this.optArr);
  }

  removeOpt(opt: string): void{
    this.optIndex = this.optArr.indexOf(opt);
    this.optArr.splice(this.optIndex, 1);
    if (this.optArr.length >= 2 && this.optArr.length <= 10) {
      this.isConfirm = true;
    } else {
      this.isConfirm = false;
    }
    if (this.optArr.length < 10) {
      this.disableFlag = false;
      this.fieldFlag = true;
    } else {
      this.disableFlag = true;
    }

    this.dupOpts = this.hasDupOpt(this.optArr);
  }

  editOpt(opt: string): void{
    this.opts = opt;
    this.optIndex = this.optArr.indexOf(opt);
    this.disableFlag = true;
    if (this.optArr.length <= 10) {
      this.updateFlag = true;
      if(this.optArr.length == 10) {
        this.fieldFlag = true;
      }
    } else {
      this.updateFlag = false;
    }

    this.dupOpts = this.hasDupOpt(this.optArr);
  }

  updateOpt(opt: string): void {
    if(opt.length > 0){      
      this.optArr.splice(this.optIndex, 1, opt);
      this.opts = '';
      if (this.optArr.length <= 10) {
        if(this.optArr.length == 10) {
          this.disableFlag = true;
          this.updateFlag = false;
          this.fieldFlag = false;
          return;
        }
        this.updateFlag = false;
        this.disableFlag = false;
      } else {
        this.updateFlag = true;
        this.disableFlag = true;
      }
    }else{
      // this.oneSnackBar.open('Please Update your options', OneSnackBarType.ERROR);
    }

    this.dupOpts = this.hasDupOpt(this.optArr);
  }

  onCancel(): void {
    this.cancelEvent.emit();
  }

  onConfirm() {
    let cloneObj = Object.assign({}, this.optArr);
    let cloneArr = Object.values(cloneObj);
    const typeValue = this.extractTypeValue(this.feedbackType);
    this.confirmEvent.emit({ 
      optArr: cloneArr, 
      status: 'confirm',
      feedbackType: typeValue 
    });
  }

  hasDupOpt(arr){
    const dupOptsFound = arr.some(item => arr.indexOf(item) !== arr.lastIndexOf(item));
    return dupOptsFound;
  }
}
